import React, { useRef } from "react";
import ReactModal from "react-modal";
import { LeadsTransferringPopup, PopupTemplate } from "src/components";
import { useAppDispatch } from "src/hooks/useRedux";
import { resetPopupInfo } from "src/redux/slices/popupSlice/popupSlice";
import { POPUP_CONTENT } from "src/utils/types";
import styles from "./style.module.scss";
import "animate.css/animate.min.css";
import { useFocusableElements } from "src/hooks/useFocusableElements";
import { usePreventScroll } from "src/hooks/usePreventScroll";

import { POPUP_TYPE } from "src/utils/enums";
import { useIsMobile } from "src/hooks/useIsMobile";
type IPopup = {
  popupInfo: POPUP_CONTENT;
};
const Modal = ReactModal as any;

const Content = ({ data, updateFoucse }: {data: any, updateFoucse: () => void}) => {
  let content;

  const {
    type,
    img,
    mobileImg,
    title,
    subTitle,
    body,
    withButton,
    okBtnText,
    cancelBtnText,
    strings,
    hideCloseBtn,
    errorStatus,
    withBuyPolicyBtn,
    buyPolicyBtnText,
  } = data;
  switch (type) {
    case POPUP_TYPE.WARNING:
      content = (
        <PopupTemplate
          popupType={POPUP_TYPE.WARNING}
          title={title}
          subTitle={subTitle}
          body={body}
          img={img}
          mobileImg={mobileImg}
          withButton={withButton}
          okBtnText={okBtnText}
          cancelBtnText={cancelBtnText}
          hideCloseBtn={hideCloseBtn}
          errorStatus={errorStatus}
          withBuyPolicyBtn={withBuyPolicyBtn}
          buyPolicyBtnText={buyPolicyBtnText}
        />
      );
      break;
    case POPUP_TYPE.LEADS_TRANSFERRING_POPUP:
      content = (
        <LeadsTransferringPopup
          mobileImg={mobileImg}
          hideCloseBtn={hideCloseBtn}
          updateFoucse={updateFoucse}
        />
      );
      break;
    case POPUP_TYPE.DIGITAL_AGENT:
      content = (
        <PopupTemplate
          popupType={POPUP_TYPE.DIGITAL_AGENT}
          strings={strings}
          title={title}
          subTitle={subTitle}
          body={body}
          img={img}
          mobileImg={mobileImg}
          withButton={withButton}
          okBtnText={okBtnText}
          cancelBtnText={cancelBtnText}
          hideCloseBtn={hideCloseBtn}
        />
      );
      break;
    case POPUP_TYPE.FAQ:
      content = (
        <PopupTemplate
          popupType={POPUP_TYPE.FAQ}
          strings={strings}
          title={title}
          subTitle={subTitle}
          body={body}
          img={img}
          mobileImg={mobileImg}
          withButton={withButton}
          okBtnText={okBtnText}
          cancelBtnText={cancelBtnText}
          hideCloseBtn={hideCloseBtn}
        />
      );

      break;
   
    default:
      content = (
        <div className={styles.modalView}>
          {/* Default content if popupType doesn't match */}
        </div>
      );
      break;
  }

  return <div className={styles.centeredView}>{content}</div>;
};


const Popup = ({ popupInfo }: IPopup) => {
  const dispatch = useAppDispatch();
  const modalRef = useRef<HTMLDivElement | null>(null);
  const isMobile = useIsMobile();
  const { updateFocusableElements } = useFocusableElements(modalRef, popupInfo.show);
  usePreventScroll(popupInfo.show);

  const handleAfterOpen = async () => {
    // Ensure the modal is opened and the ref is not null
    if (modalRef.current?.dataset.opened || !modalRef.current) return; 
    modalRef.current.dataset.opened = "true";

    // Update focusable elements and focus the first focusable element
    updateFocusableElements();
  };
  
  return (
    <>
      {!popupInfo.show ? null : (
        <div className={styles.container}>
          <Modal
            isOpen={!!popupInfo.show}
            onAfterOpen={async () => await handleAfterOpen()}
            onRequestClose={() => dispatch(resetPopupInfo())}
            overlayClassName={styles.customOverlay}
            appElement={document.getElementById("root")!}
            className={isMobile ? styles.modalMobile : styles.modal}
            contentRef={(node: HTMLDivElement) => (modalRef.current = node)}
            role="dialog"
            aria-modal="true"
          >
            <Content data={popupInfo} updateFoucse={updateFocusableElements} />
          </Modal>
        </div>
      )}
    </>
  );
};
export default Popup;
